import script from "./PhotoBooth.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoBooth.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoBooth.vue?vue&type=style&index=0&id=2cda6e1a&lang=scss"

const __exports__ = script;

export default __exports__